"use client";

import { AgoraLogo } from "@/components/custom/svgs/agora-logo";

export function BasicLogoLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="relative m-auto min-h-[100vh] w-full max-w-md flex-col items-center justify-center">
      <div className="flex h-28 items-center justify-center">
        <AgoraLogo className="fill-foreground" height={28} />
      </div>

      {children}
    </div>
  );
}
